import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import type { AppState } from '@store/store';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './PeopleOrgPage.css';
import { ELinks } from '@sharedInterfaces/globalEnums';
import { BoxButton, BoxButtons } from '@src/App/Components/Buttons/BoxButton/BoxButton';
import InnerLayout from '@src/App/Components/Core/Layouts/InnerLayout/InnerLayout';
import MvpSubNav, { type IMvpQuickAction, type IMvpRole } from '@src/App/Components/Core/MvpSubNav/MvpSubNav';
import { EIconCategory, getAppIcon } from '@src/helper/iconRegistry';

/**
 * Represents the PeopleOrgPage component.
 *
 * @returns {JSX.Element} The JSX element for the PeopleOrgPage.
 */
export default function PeopleOrgPage() {
    const navigate = useNavigate();
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).navigation;
    const [activeRole, setActiveRole] = useState('hr');

    const roles: IMvpRole[] = [
        {
            id: 'hr',
            label: 'HR',
            icon: getAppIcon(EIconCategory.EMPLOYEES),
        },
        {
            id: 'admin',
            label: 'Admin',
            icon: getAppIcon(EIconCategory.SETTINGS),
        },
    ];

    const quickActions: IMvpQuickAction[] = [
        {
            id: 'employees',
            label: 'Mitarbeitende',
            icon: getAppIcon(EIconCategory.EMPLOYEES),
            onClick: () => navigate(`/${ELinks.PEOPLE_EMPLOYEES}`),
            variant: 'primary',
        },
        {
            id: 'org-units',
            label: 'Abteilungen',
            icon: getAppIcon(EIconCategory.DEPARTMENTS),
            onClick: () => navigate(`/${ELinks.PEOPLE_ORGUNITS}`),
        },
    ];

    return (
        <>
            <MvpSubNav
                currentPageTitle="Mitarbeitende & Organisation"
                roles={roles}
                activeRole={activeRole}
                onRoleChange={setActiveRole}
                quickActions={quickActions}
            />
            <InnerLayout title={langStrings.employeeAndOEsLong}>
                <div className="page">
                    <BoxButtons>
                        <BoxButton
                            title={langStrings.employees}
                            description={langStrings.employeesDescription}
                            onClick={`/${ELinks.PEOPLE_EMPLOYEES}`}
                        />
                        <BoxButton
                            title={langStrings.orgUnits}
                            description={langStrings.orgUnitsDescription}
                            onClick={`/${ELinks.PEOPLE_ORGUNITS}`}
                        />
                    </BoxButtons>
                </div>
            </InnerLayout>
        </>
    );
}
